import {
    Award,
    Lock,
    HeartHandshake,
    Route,
    Sofa,
    Car,
    ShieldCheck,
    Clock,
    Languages,
} from "lucide-react";
import { useI18n } from "../i18n/LanguageContext";
import { useReveal } from "../hooks/useReveal";

const Differentiators = () => {
    const { t } = useI18n();
    const ref = useReveal();

    const icons = [Award, Lock, HeartHandshake, Route, Sofa, Car, ShieldCheck, Clock, Languages];

    return (
        <section
            id="diff"
            data-testid="diff-section"
            className="bg-white py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="text-center mb-16 md:mb-20 max-w-3xl mx-auto">
                    <p className="font-sans text-brand-gold text-xs uppercase tracking-[0.5em] mb-5">
                        — {t.diff.eyebrow}
                    </p>
                    <h2
                        data-testid="diff-title"
                        className="font-serif text-brand-navy text-4xl md:text-5xl lg:text-6xl leading-tight"
                    >
                        {t.diff.title}
                    </h2>
                </div>

                <div
                    ref={ref}
                    className="reveal grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-14 gap-x-8"
                >
                    {t.diff.items.map((label, i) => {
                        const Icon = icons[i];
                        return (
                            <div
                                key={i}
                                data-testid={`diff-item-${i}`}
                                className="text-center group"
                            >
                                <div className="mx-auto w-14 h-14 flex items-center justify-center border border-brand-gold/40 group-hover:border-brand-gold group-hover:bg-brand-gold/10 transition-all">
                                    <Icon className="w-6 h-6 text-brand-gold" />
                                </div>
                                <p className="mt-5 font-serif text-brand-navy text-xl md:text-2xl leading-tight">
                                    {label}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Differentiators;
